export class Timer {
  private timerId: ReturnType<typeof setInterval> | null = null;
  private startTime = 0;
  private pausedDuration = 0;

  constructor(private readonly onTick: (seconds: number) => void) { }

  start(): void {
    if (this.timerId) {
      return;
     }

    this.startTime = Date.now() - this.pausedDuration;
    this.timerId = setInterval(() => {
      this.onTick(Math.floor((Date.now() - this.startTime) / 1000));
    }, 1000);
  }

  pause(): void {
    if (!this.timerId) {
      return;
    }

    this.pausedDuration = Date.now() - this.startTime;
    clearInterval(this.timerId);
    this.timerId = null;
  }

  stop(): void {
    if (this.timerId) {
      clearInterval(this.timerId);
      this.timerId = null;
    }
    this.pausedDuration = 0;
    this.startTime = 0;
  }

  getElapsed(): number {
    if (!this.startTime) { return 0 };
    return Math.floor((Date.now() - this.startTime) / 1000);
  }
}
